/**
 * User-visible fallback strings for non-React code paths (e.g. API helpers).
 * Prefer i18n in components when possible.
 */
export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again.";
